import * as types from '../mutations-types'

// initial state
const state = {
  setting: {
    achievement_set: {}
  }
}

// actions
const actions = {}

// mutations
const mutations = {
  [types.SET_PERFORMANCE_SETTING](state, data) {
    state.setting = data
  }
}
// getters
const getters = {
  getPerformanceSetting: state => index => {
    return state.setting
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
